
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenCommunityMember } from './GenCommunityMember';
import { GenUploadedFile } from './GenUploadedFile';

export class GenCommunity {

    id: number;
    description: string;
    displayName: string;
    files: GenUploadedFile[];
    members: GenCommunityMember[];
    uiHandle: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genCommunity: GenCommunity);
    constructor( id: number );

    constructor( input?: GenCommunity|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.description = input.description; // string [string]
            this.displayName = input.displayName; // string [string]
            if ( input.files && input.files.map ) { // list [GenUploadedFile]
                this.files = input.files.map( ( x: GenUploadedFile ) => {
                    return new GenUploadedFile( x );
                } );
            } else {
                this.files = input.files;
            }
            if ( input.members && input.members.map ) { // list [GenCommunityMember]
                this.members = input.members.map( ( x: GenCommunityMember ) => {
                    return new GenCommunityMember( x );
                } );
            } else {
                this.members = input.members;
            }
            this.uiHandle = input.uiHandle; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenCommunity[] {
        if (arr && arr.map) {
          return arr.map(a => new GenCommunity(a));
        } else {
          return [];
        }
    }
}

